import React, { useState } from 'react';
import Swal from 'sweetalert2';
import classroomService from '../../services/classroomService';
import utils from '../../utils/generalFunctions';
import HtmlEditor from '../HtmlEditor';

// Formulario de una sección con HTML libre (Contenido, Recursos,
// Actividades, Evaluaciones por defecto, o el nombre que el docente quiera).
const ClassroomSectionForm = ({ intervalId, section, onClose }) => {
    const initData = {
        sectionId: section?.sectionId || 0,
        intervalId,
        name: section?.name || '',
        icon: section?.icon || '',
        descriptionHtml: section?.descriptionHtml || '',
        orden: section?.orden ?? 0,
        isVisible: section?.isVisible ?? false,
        isActive: section?.isActive ?? true
    };
    const [formData, setFormData] = useState(initData);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name) {
            Swal.fire('Campo obligatorio', 'El nombre de la sección es obligatorio.', 'error');
            return;
        }
        const user = utils.getUserInformation();
        const payload = { ...formData, createdUser: user?.userId, modificationUser: user?.userId };
        try {
            // El backend devuelve el registro ya confirmado en la base de
            // datos — se lo pasamos al padre para actualizar el estado
            // local sin volver a pedir todo el árbol.
            const guardado = formData.sectionId > 0
                ? await classroomService.updateSection(payload)
                : await classroomService.createSection(payload);
            Swal.fire('Listo', 'Sección guardada con éxito.', 'success');
            if (onClose) onClose(guardado);
        } catch (error) {
            console.error(error);
            Swal.fire('Ha ocurrido un error', 'Por favor intentelo más tarde', 'error');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="container-fluid mt-2">
            <div className="row">
                <div className="col-md-8 mb-3">
                    <label className="form-label">Nombre de la sección *</label>
                    <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder='Ej: "Contenido", "Recursos", "Tema 1"...'
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-4 mb-3">
                    <label className="form-label">Ícono (emoji o clase)</label>
                    <input type="text" className="form-control" name="icon" placeholder="📚 o fa-book" value={formData.icon} onChange={handleChange} />
                </div>
            </div>
            <div className="mb-3">
                <label className="form-label">Contenido (HTML)</label>
                <HtmlEditor
                    value={formData.descriptionHtml}
                    onChange={(value) => setFormData((prev) => ({ ...prev, descriptionHtml: value }))}
                    placeholder="Presenta esta sección a los estudiantes..."
                />
            </div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Orden</label>
                    <input type="number" className="form-control" name="orden" value={formData.orden} onChange={handleChange} />
                </div>
                <div className="col-md-6 mb-3 d-flex align-items-end">
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" id="sectionVisible" name="isVisible" checked={formData.isVisible} onChange={handleChange} />
                        <label className="form-check-label" htmlFor="sectionVisible">Visible para los estudiantes</label>
                    </div>
                </div>
            </div>
            <button type="submit" className="btn btn-primary mt-2">Guardar</button>
        </form>
    );
};

export default ClassroomSectionForm;
